var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57895 15.8929C5.79613 16.8501 7.33141 17.4211 9 17.4211C10.6686 17.4211 12.2039 16.8501 13.4211 15.8929",
    stroke: "#FF9D2E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89473 3.41988C3.96897 4.31887 1.8421 7.04266 1.8421 10.2632C1.8421 11.0736 1.97679 11.8526 2.22501 12.579",
    stroke: "#FF9D2E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1053 3.41988C14.031 4.31887 16.1579 7.04266 16.1579 10.2632C16.1579 11.0736 16.0232 11.8526 15.775 12.579",
    stroke: "#FF9D2E",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.4737C17 15.0386 16.7775 15.5515 16.4155 15.9296C16.0322 16.3298 15.4926 16.5789 14.8947 16.5789C13.732 16.5789 12.7895 15.6364 12.7895 14.4737C12.7895 13.6273 13.2889 12.8976 14.0091 12.5632C14.2783 12.4382 14.5784 12.3684 14.8947 12.3684C16.0574 12.3684 17 13.311 17 14.4737Z",
    stroke: "#FF9D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21053 14.4737C5.21053 15.0386 4.98804 15.5515 4.62598 15.9296C4.24274 16.3298 3.70312 16.5789 3.10526 16.5789C1.94256 16.5789 1 15.6364 1 14.4737C1 13.6273 1.49943 12.8976 2.21965 12.5632C2.48886 12.4382 2.78891 12.3684 3.10526 12.3684C4.26796 12.3684 5.21053 13.311 5.21053 14.4737Z",
    stroke: "#FF9D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1053 3.10526C11.1053 3.67015 10.8828 4.18303 10.5207 4.56114C10.1375 4.96135 9.59786 5.21053 9.00001 5.21053C7.83731 5.21053 6.89474 4.26796 6.89474 3.10526C6.89474 2.25891 7.39416 1.5292 8.11441 1.19478C8.38359 1.06978 8.68367 1 9.00001 1C10.1627 1 11.1053 1.94256 11.1053 3.10526Z",
    stroke: "#FF9D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleActive);
export default __webpack_public_path__ + "static/media/circleActive.f44be6e872e15991e28e47e6fced1a79.svg";
export { ForwardRef as ReactComponent };